import FilledInput from '@material-ui/core/FilledInput';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';

import { baseTheme } from '../../../theme';

interface ILockedStandardInputComponentProps {
  id: string;
  label: string;
  value: string | null | undefined;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      input: {
        backgroundColor: theme.palette.background.default,
        color: theme.palette.primary.main,
        borderRadius: '10px',
        paddingRight: '0',
      },
      label: {
        color: theme.palette.primary.main,
        borderRadius: '10px',
      },
      lockIcon: {
        width: '1.2em',
      },
    }),
);

export default function LockedStandardInputComponent(
    props: ILockedStandardInputComponentProps,
) {
  const { id, label, value  } = props;
  const classes = useStyles(baseTheme);
  const voidFunction = (event: any) => null;
  return (
        <>
            <InputLabel htmlFor={`filled-${id}`} className={classes.label}>{label}</InputLabel>
            <FilledInput
                id={`filled-${id}`}
                type="text"
                value={value}
                onChange={voidFunction}
                className={classes.input}
                endAdornment={
                    <InputAdornment position="end">
                        <IconButton
                            onClick={voidFunction}
                        >
                            <img alt="lock" src="/images/lock.svg" className={classes.lockIcon}/>
                        </IconButton>
                    </InputAdornment>
                }
            />
        </>
  );
}
